import { useState } from "react";
import { Row, Col, Card, Form, Label, Input, Collapse, Alert } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import {
  GetAvailableModuleAnswers,
  GetCoursesByClassId,
  GetResultsByProgramId,
  GetCoursesWithResultsByStudentId,
} from "../../../actions/teacherQueries";
import { PacmanLoader } from "react-spinners";
import CourseItem from "../../../components/Course/CourseItem";
import DataLoadError from "../../../components/DataLoadError/DataLoadError";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CardHeader from "reactstrap/lib/CardHeader";
import CardBody from "reactstrap/lib/CardBody";

function TeacherCoursesView(props) {
  const intl = useIntl();
  const programCourses = GetResultsByProgramId(props.programId, {
    enabled: props.level === "Program" && !!props.programId,
  });

  const classCourses = GetCoursesByClassId(props.classId, {
    enabled: props.level === "Class" && !!props.classId,
  });

  const studentCourses = GetCoursesWithResultsByStudentId(props.studentId, {
    enabled: props.level === "Student" && !!props.studentId,
  });

  const coursesData =
    props.level === "Program"
      ? programCourses
      : props.level === "Class"
      ? classCourses
      : studentCourses;

  const [filterSearch, setFilterSearch] = useState("");
  const [toggleModules, setToggleModules] = useState([]);
  const [collapseLicenses, setCollapseLicenses] = useState([]);
  const [openedDocuments, setOpenedDocuments] = useState([]);
  const availableModuleAnswers = GetAvailableModuleAnswers();

  const filterSearchfunc = (event) => {
    setFilterSearch(event.target.value);
  };

  const stopEnter = (event) => {
    if (event.which === 13 /* Enter */) {
      event.preventDefault();
    }
  };

  const collapseLicensesfunc = (license) => {
    if (collapseLicenses.indexOf(license) === -1) {
      setCollapseLicenses([...collapseLicenses, license]);
    } else {
      setCollapseLicenses(collapseLicenses.filter((l) => l !== license));
    }
  };

  if (coursesData.isError) {
    return <DataLoadError />;
  }

  if (coursesData.isPending) {
    return (
      <div className="inline-pacman-loader">
        <PacmanLoader color="#20a8d8" size={20} />
      </div>
    );
  }

  let filteredList = coursesData.data;

  if (filterSearch.length > 0) {
    filteredList = coursesData.data.filter(
      (course) =>
        course.courseName.toLowerCase().indexOf(filterSearch.toLowerCase()) !==
        -1
    );
  }

  const toggleModule = (courseId) => {
    if (!toggleModules.includes(courseId)) {
      if (openedDocuments.includes(courseId)) {
        setOpenedDocuments(openedDocuments.filter((id) => id !== courseId));
      }
      setToggleModules([...toggleModules, courseId]);
    } else {
      setToggleModules(toggleModules.filter((id) => id !== courseId));
    }
  };

  const toggleDocuments = (courseId) => {
    if (openedDocuments.includes(courseId)) {
      setOpenedDocuments(openedDocuments.filter((id) => id !== courseId));
    } else {
      if (toggleModules.includes(courseId)) {
        setToggleModules(toggleModules.filter((id) => id !== courseId));
      }
      setOpenedDocuments([...openedDocuments, courseId]);
    }
  };

  let licenses = [];
  coursesData.data.forEach((x) => {
    if (licenses.indexOf(x.programLicenseName) === -1)
      licenses.push(x.programLicenseName);
  });

  let mappedLicenses = [];

  mappedLicenses = licenses.map((license, i) => {
    const coursesForLicense = filteredList.filter(
      (x) => x.programLicenseName === license,
    );
    const licenseExpired =
      coursesForLicense.length > 0 &&
      coursesForLicense.every((course) => course.licenseExpired);
    const programName = coursesForLicense[0]?.programName;

    return (
      <Col lg="12" key={i + props.objId}>
        <Card>
          <CardHeader
            style={{ cursor: "pointer" }}
            title={intl.formatMessage({ id: "CollapseExpand" })}
            onClick={() => collapseLicensesfunc(license)}
          >
            {license}
          </CardHeader>
          <Collapse isOpen={collapseLicenses.indexOf(license) === -1}>
            <CardBody>
              {licenseExpired ? (
                <Alert color="warning" className="m-2 py-2 small">
                  <FormattedMessage
                    id="ProgramLicenseExpired"
                    values={{ programName }}
                  />
                </Alert>
              ) : (
                ""
              )}
              <Row
                className="p-2"
                inert={licenseExpired}
                style={licenseExpired ? { opacity: 0.5 } : undefined}
              >
                {coursesForLicense
                  .sort((a, b) => {
                    return a.courseName > b.courseName ? 1 : 0;
                  })
                  .map((course) => (
                    <CourseItem
                      course={course}
                      key={course.id + props.objId}
                      teacherInfo={props.teacherInfo}
                      displayDocuments={props.displayDocuments}
                      toggleModules={toggleModule}
                      modulesIsOpen={toggleModules.indexOf(course.id) > -1}
                      documentIsOpen={openedDocuments.indexOf(course.id) > -1}
                      toggleDocumentOpen={toggleDocuments}
                      openedDocuments={openedDocuments}
                      availableModuleAnswers={availableModuleAnswers}
                    />
                  ))}
              </Row>
            </CardBody>
          </Collapse>
        </Card>
      </Col>
    );
  });

  return (
    <div className="animated fadeIn">
      <Card body className="rounded border-0 shadow-sm ms-2 me-2">
        <Form
          onKeyPress={(event) => stopEnter(event)}
          className="d-flex align-items-center "
        >
          <div className="w-100 position-relative">
            <FontAwesomeIcon
              icon="search"
              className="position-absolute top-50 start-0 translate-middle-y ms-3"
            />
            <Label for="searchInput" className="visually-hidden">
              <FormattedMessage id="Search" />
            </Label>
            <Input
              id="searchInput"
              className="rounded-4 ps-5"
              onChange={(event) => filterSearchfunc(event)}
              placeholder={intl.formatMessage({ id: "CourseName" })}
            />
          </div>
        </Form>
      </Card>
      <Row>{mappedLicenses}</Row>
    </div>
  );
}

export default TeacherCoursesView;
